// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  .black-background{
    width: 100%;
    background-color: black;
    height: 480px;
    align-items: center;
    display: flex;
  }
  .container {
    display: flex;
    width: 90%;
    align-items: center;
  }
  .service-i-container{
    display: flex;
    width: 90%;
    align-items: center;
  }
  
  .cards-container {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto; /* Allow horizontal scrolling for cards */
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    width: 100%;
  }
  .cards-container::-webkit-scrollbar {
    display: none; /* Hide scrollbar for WebKit browsers (e.g., Chrome, Safari) */
  }
  
  .cards-container {
    scrollbar-width: none; /* Hide scrollbar for Firefox */
  }

  .service-card-title{
    font-size: 35px;
    font-weight: bolder;
    margin-top: 180px;
    margin-left: 100px;
    max-width: 70%;
  }

  
  .service-card-info-description{
    font-size: 20px;
  }

  .card {
    margin: 10px;
    flex: 0 0 auto;
    position: relative;
    display: flex;
    flex-direction: column;
    width: 400px;
    height: 300px;
    font-size: 30px;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    color:white;
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.5); /* Adjust opacity as needed */
  }

  .card:hover {
    background-color: rgba(0, 0, 0, 0.6); /* Adjust opacity as needed */
  }
  
  /* Overlay effect for content */
  .card::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background:linear-gradient(to bottom, rgba(11, 151, 220, 0.6), rgba(0, 0, 0, 0.8));
    opacity: 0; /* Initially transparent */
    transition: opacity 0.3s; /* Fade effect */
  }
  
  .card:hover::after {
    opacity: 1; /* Show overlay on hover */
  }
  
  .arrow {
    width: 50px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 24px;
    color: gray;
  }
  
  .arrow:hover {
    color: black;
  }
  
  .left {
    transform: rotate(180deg);
  }

  .card-flex-container{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .flex-container{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .left-align-vertical-text{
    writing-mode: vertical-rl; /* vertical writing mode, right to left */
    text-orientation: mixed;
    font-size: 40px;
    color: white;
    width: 10%;
  }


  
  
  .image {
    flex: 1 1;
    background-size: cover;
    background-position: center;
  }
  
  .content {
    position: absolute;
    z-index: 10;
    top: 0px;
    left:0px;
    background-color: rgba(0, 0, 0, 0.5); /* Adjust opacity as needed */
    width: 100%;
    height: 100%;
    font-weight: bold;
  }


  
  .description {
    margin-top: 8px;
    font-size: 14px;
  }

  @media screen and (max-width: 768px) {
    #root{
      overflow-x: hidden; /* Disable horizontal scrolling on phone screens */
    }
    .card {
      margin: 5px;
      width: 160px;
      height: 150px;
      font-size: 12px;
    }
    .card-flex-container{
      display: block;  /* Minimum 2 columns, with each column having a minimum width of 200px */
      gap: 10px; /* Adjust as needed to add space between grid items */
      width: 100%;
    }
    .service-i-container{
      width: 100%;
    }
    .arrow{
      display: none;
    }
    .service-card-title{
      margin-top: 90px;
      margin-left: 25px;
      font-size: 14px;
    }
    .description{
      font-size: 10px;
      background-color: rgba(0, 0, 0, 0.5);
      padding: 5px 10px;
      border-radius: 5px;
    }
    .left-align-vertical-text{
      writing-mode: vertical-rl; /* vertical writing mode, right to left */
      text-orientation: mixed;
      font-size: 20px;
      color: white;
      width: 8%;
    }
    .container {
      width: 92%;
    }

    .cards-container {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
      gap: 10px; /* Adjust as needed to add space between grid items */
      width: 100%;
    }
    .about-us-container {
      width: 100%;
    }
    
    .left-align-vertical-text {
      writing-mode:horizontal-tb; /* vertical writing mode, right to left */
      text-orientation: mixed;
      width: -moz-fit-content;
      width: fit-content;
      margin: auto;
      margin-top: 20px;
      margin-bottom: 20px;
    }
    
    .black-background{
      width: 100%;
      height: max-content;
      padding-bottom: 30px;
      overflow-x: hidden; /* Disable horizontal scrolling on phone screens */

    }
    .service-card-info-description{
      font-size: 10px;
      background-color: rgba(0, 0, 0, 0.5); /* Black with 50% opacity */
    }
  
  }`, "",{"version":3,"sources":["webpack://./src/components/LandingPageComponents/ServiceQuickInfo/style.css"],"names":[],"mappings":";EACE;IACE,WAAW;IACX,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,aAAa;IACb,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,gBAAgB,EAAE,yCAAyC;IAC3D,uBAAuB;IACvB,iCAAiC;IACjC,WAAW;EACb;EACA;IACE,aAAa,EAAE,8DAA8D;EAC/E;;EAEA;IACE,qBAAqB,EAAE,+BAA+B;EACxD;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;;EAGA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,0CAA0C;IAC1C,WAAW;IACX,eAAe;IACf,oCAAoC,EAAE,6BAA6B;EACrE;;EAEA;IACE,oCAAoC,EAAE,6BAA6B;EACrE;;EAEA,+BAA+B;EAC/B;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,kFAAkF;IAClF,UAAU,EAAE,0BAA0B;IACtC,wBAAwB,EAAE,gBAAgB;EAC5C;;EAEA;IACE,UAAU,EAAE,0BAA0B;EACxC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;EACb;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;EACb;EACA;IACE,yBAAyB,EAAE,yCAAyC;IACpE,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,UAAU;EACZ;;;;;EAKA;IACE,SAAO;IACP,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,QAAQ;IACR,oCAAoC,EAAE,6BAA6B;IACnE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;;;EAIA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE;MACE,kBAAkB,EAAE,kDAAkD;IACxE;IACA;MACE,WAAW;MACX,YAAY;MACZ,aAAa;MACb,eAAe;IACjB;IACA;MACE,cAAc,GAAG,wEAAwE;MACzF,SAAS,EAAE,qDAAqD;MAChE,WAAW;IACb;IACA;MACE,WAAW;IACb;IACA;MACE,aAAa;IACf;IACA;MACE,gBAAgB;MAChB,iBAAiB;MACjB,eAAe;IACjB;IACA;MACE,eAAe;MACf,oCAAoC;MACpC,iBAAiB;MACjB,kBAAkB;IACpB;IACA;MACE,yBAAyB,EAAE,yCAAyC;MACpE,uBAAuB;MACvB,eAAe;MACf,YAAY;MACZ,SAAS;IACX;IACA;MACE,UAAU;IACZ;;IAEA;MACE,aAAa;MACb,2DAA2D;MAC3D,SAAS,EAAE,qDAAqD;MAChE,WAAW;IACb;IACA;MACE,WAAW;IACb;;IAEA;MACE,0BAA0B,EAAE,yCAAyC;MACrE,uBAAuB;MACvB,uBAAkB;MAAlB,kBAAkB;MAClB,YAAY;MACZ,gBAAgB;MAChB,mBAAmB;IACrB;;IAEA;MACE,WAAW;MACX,mBAAmB;MACnB,oBAAoB;MACpB,kBAAkB,EAAE,kDAAkD;;IAExE;IACA;MACE,eAAe;MACf,oCAAoC,EAAE,2BAA2B;IACnE;;EAEF","sourcesContent":["\n  .black-background{\n    width: 100%;\n    background-color: black;\n    height: 480px;\n    align-items: center;\n    display: flex;\n  }\n  .container {\n    display: flex;\n    width: 90%;\n    align-items: center;\n  }\n  .service-i-container{\n    display: flex;\n    width: 90%;\n    align-items: center;\n  }\n  \n  .cards-container {\n    display: flex;\n    flex-wrap: nowrap;\n    overflow-x: auto; /* Allow horizontal scrolling for cards */\n    scroll-behavior: smooth;\n    -webkit-overflow-scrolling: touch;\n    width: 100%;\n  }\n  .cards-container::-webkit-scrollbar {\n    display: none; /* Hide scrollbar for WebKit browsers (e.g., Chrome, Safari) */\n  }\n  \n  .cards-container {\n    scrollbar-width: none; /* Hide scrollbar for Firefox */\n  }\n\n  .service-card-title{\n    font-size: 35px;\n    font-weight: bolder;\n    margin-top: 180px;\n    margin-left: 100px;\n    max-width: 70%;\n  }\n\n  \n  .service-card-info-description{\n    font-size: 20px;\n  }\n\n  .card {\n    margin: 10px;\n    flex: 0 0 auto;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    width: 400px;\n    height: 300px;\n    font-size: 30px;\n    border-radius: 10px;\n    overflow: hidden;\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n    color:white;\n    cursor: pointer;\n    background-color: rgba(0, 0, 0, 0.5); /* Adjust opacity as needed */\n  }\n\n  .card:hover {\n    background-color: rgba(0, 0, 0, 0.6); /* Adjust opacity as needed */\n  }\n  \n  /* Overlay effect for content */\n  .card::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background:linear-gradient(to bottom, rgba(11, 151, 220, 0.6), rgba(0, 0, 0, 0.8));\n    opacity: 0; /* Initially transparent */\n    transition: opacity 0.3s; /* Fade effect */\n  }\n  \n  .card:hover::after {\n    opacity: 1; /* Show overlay on hover */\n  }\n  \n  .arrow {\n    width: 50px;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    font-size: 24px;\n    color: gray;\n  }\n  \n  .arrow:hover {\n    color: black;\n  }\n  \n  .left {\n    transform: rotate(180deg);\n  }\n\n  .card-flex-container{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n  }\n  .flex-container{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n  }\n  .left-align-vertical-text{\n    writing-mode: vertical-rl; /* vertical writing mode, right to left */\n    text-orientation: mixed;\n    font-size: 40px;\n    color: white;\n    width: 10%;\n  }\n\n\n  \n  \n  .image {\n    flex: 1;\n    background-size: cover;\n    background-position: center;\n  }\n  \n  .content {\n    position: absolute;\n    z-index: 10;\n    top: 0px;\n    left:0px;\n    background-color: rgba(0, 0, 0, 0.5); /* Adjust opacity as needed */\n    width: 100%;\n    height: 100%;\n    font-weight: bold;\n  }\n\n\n  \n  .description {\n    margin-top: 8px;\n    font-size: 14px;\n  }\n\n  @media screen and (max-width: 768px) {\n    #root{\n      overflow-x: hidden; /* Disable horizontal scrolling on phone screens */\n    }\n    .card {\n      margin: 5px;\n      width: 160px;\n      height: 150px;\n      font-size: 12px;\n    }\n    .card-flex-container{\n      display: block;  /* Minimum 2 columns, with each column having a minimum width of 200px */\n      gap: 10px; /* Adjust as needed to add space between grid items */\n      width: 100%;\n    }\n    .service-i-container{\n      width: 100%;\n    }\n    .arrow{\n      display: none;\n    }\n    .service-card-title{\n      margin-top: 90px;\n      margin-left: 25px;\n      font-size: 14px;\n    }\n    .description{\n      font-size: 10px;\n      background-color: rgba(0, 0, 0, 0.5);\n      padding: 5px 10px;\n      border-radius: 5px;\n    }\n    .left-align-vertical-text{\n      writing-mode: vertical-rl; /* vertical writing mode, right to left */\n      text-orientation: mixed;\n      font-size: 20px;\n      color: white;\n      width: 8%;\n    }\n    .container {\n      width: 92%;\n    }\n\n    .cards-container {\n      display: grid;\n      grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n      gap: 10px; /* Adjust as needed to add space between grid items */\n      width: 100%;\n    }\n    .about-us-container {\n      width: 100%;\n    }\n    \n    .left-align-vertical-text {\n      writing-mode:horizontal-tb; /* vertical writing mode, right to left */\n      text-orientation: mixed;\n      width: fit-content;\n      margin: auto;\n      margin-top: 20px;\n      margin-bottom: 20px;\n    }\n    \n    .black-background{\n      width: 100%;\n      height: max-content;\n      padding-bottom: 30px;\n      overflow-x: hidden; /* Disable horizontal scrolling on phone screens */\n\n    }\n    .service-card-info-description{\n      font-size: 10px;\n      background-color: rgba(0, 0, 0, 0.5); /* Black with 50% opacity */\n    }\n  \n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
